<flexyoo-common-list
  [dataSource]="dataSource"
  [columns]="columns"
  (pagerChanged)="dataSource.nextPager($event)"
  (sortChange)="dataSource.setSort($event)"
>
  <flexyoo-employee-budget-list-filter
    ngProjectAs="header"
    [years]="years()"
    (applyFilter)="dataSource.nextFilter($event)"
  ></flexyoo-employee-budget-list-filter>
</flexyoo-common-list>
